/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AICategory
 */
export interface AICategory {
    /**
     * 
     * @type {string}
     * @memberof AICategory
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof AICategory
     */
    readonly annotationCount: number;
    /**
     * 
     * @type {string}
     * @memberof AICategory
     */
    readonly sampleAnnotation: string;
    /**
     * 
     * @type {string}
     * @memberof AICategory
     */
    readonly connection: string;
    /**
     * 
     * @type {string}
     * @memberof AICategory
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AICategory
     */
    dataset: string;
}

export function AICategoryFromJSON(json: any): AICategory {
    return AICategoryFromJSONTyped(json, false);
}

export function AICategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AICategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'annotationCount': json['annotation_count'],
        'sampleAnnotation': json['sample_annotation'],
        'connection': json['connection'],
        'name': json['name'],
        'dataset': json['dataset'],
    };
}

export function AICategoryToJSON(value?: AICategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'dataset': value.dataset,
    };
}


